import { Component, OnInit, ViewChild } from '@angular/core';
import { ElementRef } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ValidationService } from '../../services/validation.service';
import { PagerService } from '../../services/index';
import * as $ from 'jquery/dist/jquery.min.js';
declare var jQuery: any;

@Component({
	selector: 'app-story-video',
	templateUrl: './story-video.component.html',
	styleUrls: ['./story-video.component.css']
})
export class StoryVideoComponent implements OnInit {
	storyVideoForm: any;
	pager: any = {};
	pagedItems: any[];
	total: any;
	limit: any;
	pageNo: any;
	searchStr: any = '';
	modalTitle: any;
	storyVideoList: any;
	isStoryVideoAvailable: boolean = true;
	btnTitle: any;
	selectedStoryVideoId: any
	isActivatedAdd: boolean = false;
	isActivatedEdit: boolean = false;
	isActivatedDelete: boolean = false;
	src: String = "";
	viewType: string = "";
	currentVideo: any;
	question: any;
	user_id: any;
	config = {
		width: "400px", //width of slides defaults to 800px
		height: "400px", //height of slides defaults to 300px
		autoPlay: true, //autoplay required or not defaults to false
		delay: 3000, // delay for autoplay
	}
	@ViewChild('videoPlayer') videoplayer: ElementRef;

	constructor(private commonService: CommonService, private authService: AuthService,
		private router: Router, private validationService: ValidationService, private activatedRoute: ActivatedRoute,
		private pagerService: PagerService) {
		this.activatedRoute.params.subscribe((params: any) => {
			this.question = params.question
			this.user_id = params.story_id
		})
	}


	ngOnInit() {
		$(".navbar-brand").text("Story Video");
		this.storyVideoForm = new FormGroup({

		});

		this.pageNo = 1;
		this.limit = 10;
		this.getStoryVideoList(this.pageNo, this.limit, this.searchStr);

	}

	// Get user story video List
	getStoryVideoList = function (pageNo, limit, SeachStr) {
		this.commonService.process();
		this.authService.getUserStoryVideoDataList(this.user_id, pageNo, limit, SeachStr).subscribe(data => {
			console.log("getUserStoryVideoDataList", data)
			if (data.success) {
				this.isStoryVideoAvailable = true;
				this.storyVideoList = data.videoData;
				this.total = data.total;
				this.setPage(pageNo, true);
				this.pageNo = pageNo;
			}
			else {
				this.isStoryVideoAvailable = false;
				this.storyVideoList = [];
			}
			this.commonService.hideProcess();
		});
	}

	// Pagination
	setPage(page: number, param) {
		if (page < 1 || page > this.pager.totalPages) {
			return;
		}
		//this.pageNo = page;
		this.pager = this.pagerService.getPager(this.total, page);

		// get current page of items
		this.pagedItems = this.storyVideoList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		if (!param) {
			this.getStoryVideoList(page, this.limit, this.searchStr);
		}
	}

	// Delete Selected story video
	deleteSelectedStoryVideo = function (storyVideo) {
		this.isActivatedAdd = false;
		this.isActivatedEdit = false;
		this.isActivatedDelete = true;
		this.modalTitle = "Delete Video";
		this.btnTitle = "Yes";
		this.selectedStoryVideoId = storyVideo._id;
	}

	updateViolationVideo = function (videoData) {

	}
	// manage Story video
	manageStoryVideo = function (storyVideoForm,) {
		if (this.storyVideoForm.valid && this.isActivatedAdd) {

		}
		else if (this.storyVideoForm.valid && this.isActivatedEdit) {

		}
		else if (this.isActivatedDelete) {

			storyVideoForm._id = this.selectedStoryVideoId;
			this.btnTitle = "Deleting...";
			jQuery(':button[type="submit"]').attr('disabled', true);
			this.authService.manageStoryVideo(storyVideoForm, "delete", this.selectedStoryVideoId).subscribe(data => {
				if (data.success) {

					this.getStoryVideoList(this.pageNo, this.limit, this.searchStr);
					jQuery.growl.notice({ title: 'Success', message: data.message });
				}
				else {
					jQuery.growl.error({ title: 'Error', message: data.error });
				}
				jQuery(':button[type="submit"]').attr('disabled', false);
				this.authService.cancelProcess();
			});
		}
		else {
			this.validationService.validateAllFormFields(this.storyVideoForm);
		}
	}


	// Search story video
	searchStoryVideo = function () {
		this.searchStr = jQuery("#search").val();
		this.getStoryVideoList(1, this.limit, this.searchStr);
	}

	toggleVideo(event: any) {
		this.videoplayer.nativeElement.play();
	}

	playVideo(data) {
		console.log(data)
		this.currentVideo = data;
	}
}


// WEBPACK FOOTER //
// /Users/vishitamandloi/Documents/vishitaProjects/waz/angular/adminportal/waz-admin-panel/src/app/dashboard/story-video/story-video.component.ts